var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDocu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.497 0.521484H4.75158C2.25871 0.521484 0.254639 2.52556 0.254639 5.01843V13.9879C0.254639 15.2343 1.25668 16.2364 2.50311 16.2364H11.497C12.7434 16.2364 13.7455 15.2343 13.7455 13.9879V2.76996C13.7455 1.52352 12.7434 0.521484 11.497 0.521484ZM9.98173 12.497H3.99395C3.57847 12.497 3.23631 12.1549 3.23631 11.7394C3.23631 11.3239 3.57847 10.9818 3.99395 10.9818H9.98173C10.3972 10.9818 10.7394 11.3239 10.7394 11.7394C10.7394 12.1549 10.3972 12.497 9.98173 12.497ZM9.98173 8.75774H3.99395C3.57847 8.75774 3.23631 8.41558 3.23631 8.0001C3.23631 7.58462 3.57847 7.24246 3.99395 7.24246H9.98173C10.3972 7.24246 10.7394 7.58462 10.7394 8.0001C10.7394 8.41558 10.3972 8.75774 9.98173 8.75774Z",
    fill: "#141938"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocu);
export default __webpack_public_path__ + "static/media/icon-docu.ecafa5652a5b3904d6d616eeb8f27c5e.svg";
export { ForwardRef as ReactComponent };